import { Controller } from "@hotwired/stimulus"

// Lightweight auto-submit for filter forms. `submit` triggers a Turbo GET ;
// `submitDebounced` waits 250ms so search inputs don't fire on every keystroke.
export default class extends Controller {
  connect() {
    this._timer = null
  }

  submit() {
    this.element.requestSubmit()
  }

  submitDebounced() {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.element.requestSubmit(), 250)
  }
}
